import {
  LatitudeLongitudeFields,
  type MapObject,
  MapObjectTypeEnum,
  RoboticMowerAreaDetails,
} from '@fleet-bffs/api-contract';
import { computeArea, computeDistance } from '~/domain/maps/utils';
import type { MapObjectGeometryArgs } from '~/domain/roboticmower-details/models';

export const calculateMapObjectLength = (positions: LatitudeLongitudeFields[]) => {
  const path = positions.map((item) => new google.maps.LatLng(item.latitude, item.longitude));
  return path.reduce((acc, item, index) => {
    if (index > 0) {
      return acc + computeDistance(item, path[index - 1]);
    }
    return acc;
  }, 0);
};

export const calculateMapObjectArea = (positions: LatitudeLongitudeFields[]) => {
  return computeArea(
    positions.map((item) => new google.maps.LatLng(item.latitude, item.longitude))
  );
};

export const getMapObjectGeometryArgs = (
  object: Partial<MapObject>,
  areaDetails: RoboticMowerAreaDetails | undefined
): MapObjectGeometryArgs | undefined => {
  if (
    object.type === MapObjectTypeEnum.StayoutZone ||
    object.type === MapObjectTypeEnum.Island ||
    object.type === MapObjectTypeEnum.WorkArea
  ) {
    return {
      perimeterPositions: object.positions,
      areaPositions: object.positions,
    };
  }
  if (object.type === MapObjectTypeEnum.TransportPath) {
    return {
      pathPositions: object.positions,
      width: object.width,
    };
  }
  if (object.type === MapObjectTypeEnum.MaintenancePoint) {
    return {
      pathPositions: areaDetails?.maintenancePoint?.travelPath,
      width: areaDetails?.maintenancePoint?.width,
    };
  }
  return undefined;
};

export const validateLastTimeCompleted = (lastTimeCompleted: string) => {
  const date = new Date(lastTimeCompleted);
  const minDate = new Date();
  minDate.setMonth(new Date().getMonth() - 12);
  return date > minDate;
};

export const formatMapObjectWidth = (width: number) => {
  return +width.toFixed(2);
};
